import ChallengeSetListItems from '@/src/components/challenges/challengeSets/ChallengeSetList';
import React from 'react';

export const ChallengeSetsPage: React.FC = () => {
  return <ChallengeSetListItems />;
};
